export default function dateFromIC(icDate) {
  const yymmdd = `${icDate}`;
  if (yymmdd.length !== 6) {
    return false;
  }
  let year = yymmdd.substring(0, 2) - 0;
  const month = yymmdd.substring(2, 4);
  const day = yymmdd.substring(4, 6);
  if (year <= `${(new Date()).getFullYear()}`.substring(2, 4)) {
    year += 2000;
  } else {
    year += 1900;
  }
  return `${year}-${month}-${day}`;
}



// WEBPACK FOOTER //
// ./src/utils/dateFromIC.js